module.exports = __webpack_public_path__ + "static/media/tania.0d434cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Testimonial/tania.jpg
// module id = 90
// module chunks = 0